const n = /* @__PURE__ */ new Map(), o = (e, s) => {
  const t = n.get(e);
  if (t) return t;
  const r = Promise.resolve().then(() => s()).catch(() => null).finally(() => n.delete(e));
  return n.set(e, r), r;
};
export {
  o as singleOperation
};
//# sourceMappingURL=singleOperation.js.map
